/* eslint-disable jsx-a11y/anchor-is-valid */
// import React, {useEffect, useState, useRef} from "react";

const Breathe = () => {

    



    return (
        <div className="container">
            {/* <h1>Relaxer</h1> */}
            <div class="breathe" id="breathe">
                <div class="circle"></div>

                <p id="text"></p>

                <div class="pointer-container">
                    <span class="pointer"></span>
                </div>

                <div class="gradient-circle"></div>
            </div>
        </div>
    );
}

export default Breathe;